import { Injectable, inject } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import type { NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { NiceAsyncTypeaheadProvider } from "@recursyve/nice-ui-kit.v2";
import type { Observable } from "rxjs";
import { lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { SecondarySystemTypesApi } from "../apis/enums/secondary-system-types.api";
import type { SecondarySystemTypes } from "../models/secondary-system-types.model";

@Injectable()
export class SecondarySystemTypesTypeaheadApi extends NiceAsyncTypeaheadProvider<SecondarySystemTypes> {
    private readonly api = inject(SecondarySystemTypesApi);

    private readonly pageSize = 20;
    public readonly resource = "secondarySystemTypes";

    public override async getById(id: number): Promise<SecondarySystemTypes> {
        return lastValueFrom(this.api.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<SecondarySystemTypes>> {
        return this.api
            .search({
                page,
                pageSize: this.pageSize,
                searchQuery
            })
            .pipe(
                map(items => ({
                    items,
                    nextPage: items.length === this.pageSize ? page + 1 : null
                }))
            );
    }

    public override format(secondarySystemType: SecondarySystemTypes): string {
        if (!isPropertyDefined(secondarySystemType, "name")) {
            return "";
        }

        return secondarySystemType.name;
    }
}
